import { render } from "./quickmelo.vue?vue&type=template&id=e6013826&scoped=true"
import script from "./quickmelo.vue?vue&type=script&lang=js"
export * from "./quickmelo.vue?vue&type=script&lang=js"

import "./quickmelo.vue?vue&type=style&index=0&id=e6013826&scoped=true&lang=css"

import exportComponent from "D:\\startup\\gtdhtml5\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6013826"]])

export default __exports__